/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type CategoriesEditor_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CategoriesApp_viewer$ref: FragmentReference;
export type CategoriesApp_viewer = {|
  +$fragmentRefs: CategoriesEditor_viewer$ref,
  +$refType: CategoriesApp_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "CategoriesApp_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "section",
      "type": "ID!",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CategoriesEditor_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "section",
          "variableName": "section",
          "type": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6321a824c2106ca90a57a84d0ed87328';
module.exports = node;



// WEBPACK FOOTER //
// src/components/categories/__generated__/CategoriesApp_viewer.graphql.js